export default __webpack_public_path__ + "static/media/spring_button.31935aad.jpg";